import React, { useRef, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
	Button,
	DateRangePicker,
	DownloadButton,
	LoadingComponent,
	Modal,
	NoDataFoundTemplate,
	Select,
} from "../../../components/core";
import { gql, useLazyQuery, useQuery } from "@apollo/client";
import { useEffect } from "react";

import UnrecogTable from "./unrecogtable";
import {
	QUERY_COMPANY_BRANCHES,
	QUERY_COMPANY_NKCNAME,
	QUERY_Unrecognized_Waybill,
	QUERY_LOCKER_NAME,
	QUERY_LOCKER_TYPE,
} from "../../../constants/graphql/drop-off-graphql";
import PrimereactDateRange from "../../../components/core/date-range-primereact";
import { formatDateYYYYMMDD } from "../../../algorithms/date";

const UnrecognizedWaybill = () => {
	// local Variables
	const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
	const [dropOffStatusHistory, setDropOffStatusHistory] = useState([]);
	const [startDate, setStartDate] = useState(new Date());
	const [endDate, setEndDate] = useState(new Date());
	const [isLoading, setisLoading] = useState(false);

	//<SELECT> data to be queued
	const [selectedLockerType, setSelectedLockerType] = useState("-1");
	const [selectedLockerName, setSelectedLockerName] = useState("-1");
	const [selectedPartnerCompany, setSelectedPartnerCompany] = useState("-1");
	const [selectedPartnerBranch, setSelectedPartnerBranch] = useState("-1");
	const [selectedStatus, setSelectedStatus] = useState("");

	// queued variaballs
	const [lockerName, setLockerName] = useState([]);
	const [selectedRadio, setSelectedRadio] = useState("weekday");

	const [isTableEmpty, setIsTableEmpty] = useState(false);

	const dropStatus = [
		{ value: "200", name: "-- ALL --" },
		{ value: "128", name: "Claimed" },
		{ value: "110", name: "Pending" },
		{ value: "121", name: "Over Stay" },
		{ value: "130", name: "For Collect" },
		{ value: "138", name: "Revoked" },
		{ value: "118", name: "Removed" },
		{ value: "150", name: "Cancelled" },
	];

	const [validation, setValidation] = useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});

	function formatDate(inputDate) {
		if (inputDate == null) {
			return "";
		}
		const date = new Date(inputDate);
		const options = { year: "numeric", month: "short", day: "numeric" };
		return date.toLocaleDateString(undefined, options);
	}

	//GraphQL queries

	const [QUERYdropOffStatusHistory, { data, loading }] = useLazyQuery(
		QUERY_Unrecognized_Waybill,
		{ fetchPolicy: "no-cache" }
	);

	const fetchLockerType = useQuery(QUERY_LOCKER_TYPE);
	const fetchLockerName = useQuery(QUERY_LOCKER_NAME, {
		variables: {
			operatorId: operatorId,
			selectedLockerType: selectedLockerType,
		},
	});
	const fetchCompanyName = useQuery(QUERY_COMPANY_NKCNAME, {
		variables: {
			operatorId: operatorId,
		},
	});
	const fetchCompanyBranch = useQuery(QUERY_COMPANY_BRANCHES, {
		variables: {
			operatorId: operatorId,
			selectedPartnerCompany: selectedPartnerCompany,
		},
	});

	//To Fetch Table Data
	useEffect(() => {
		if (data) {
			{
				if (data.unrecognizedWaybill.length == 0) {
					console.log("no result found");
					setisLoading(false);
					setNoResultSearch(true);
					setIsTableEmpty(true);
					return;
				}
				let tempData = [];
				data.unrecognizedWaybill.forEach((element) => {
					let obj = { ...element };
					if (obj.history == "Present") {
						obj.waybill = checkIfDigitsOnly(obj.waybill);
						obj.blank = "";
						tempData.push(obj);
					}
				});
				setDropOffStatusHistory(tempData);
				console.log(tempData);
				setisLoading(false);
			}
		}
	}, [data]);

	function checkIfDigitsOnly(waybill) {
		if (/^\d+$/.test(waybill)) {
			// return waybill + '*';
			return waybill.slice(0, 1) + "*" + waybill.slice(1);
		}
		return waybill;
	}

	//To Fetch Company Branches
	const [partnerBranch, setPartnerBranch] = useState("");
	useEffect(() => {
		if (fetchCompanyBranch.data) {
			let tempData = [];
			fetchCompanyBranch.data.searchBranches.forEach((element, index) => {
				tempData.push({
					value: element.partnerBranchId,
					name: element.partnerBranch,
				});
			});
			setPartnerBranch(tempData);
		}
	}, [fetchCompanyBranch.data]);

	//To Fetch Company Name
	const [partnerCompany, setPartnerCompany] = useState("");
	useEffect(() => {
		if (fetchCompanyName.data) {
			let tempData = [];
			fetchCompanyName.data.partners.forEach((element, index) => {
				tempData.push({
					value: element.partnerId,
					name: element.companyNickname,
				});
			});
			setPartnerCompany(tempData);
		}
	}, [fetchCompanyName.data]);

	//to fetch lockerType
	const [lockerType, setLockerType] = useState();
	useEffect(() => {
		if (fetchLockerType.data) {
			let tempData = [];
			fetchLockerType.data.lockerTypes.forEach((element, index) => {
				tempData.push({
					value: element.lockerTypeId,
					name: element.lockerType,
				});
			});
			setLockerType(tempData);
		}
	}, [fetchLockerType.data]);

	//To Fetch Locker Name
	useEffect(() => {
		if (fetchLockerName.data) {
			let tempData = [
				{
					value: "200",
					name: "-- All --",
				},
			];
			fetchLockerName.data.lockers.forEach((element, index) => {
				tempData.push({
					value: element.lockerId,
					name: element.lockerName,
				});
			});
			setLockerName(tempData);
			console.log(tempData);
		}
	}, [fetchLockerName.data]);

	//Search handler
	const [searchResultHeader, setSearchResultHeader] = useState();

	function handleSearchResultHeader() {
		const lockerTypeName =
			selectedLockerType === "-1"
				? "ALL Locker types"
				: selectedLockerType === "1"
				? "Parcel Locker"
				: "Fridge Locker";

		const lockerNameValue =
			selectedLockerName != "200"
				? lockerName.find((item) => item.value === selectedLockerName)
				: "ALL Lockers";

		const lockerNameText = lockerNameValue
			? `${
					selectedLockerName === "200" ? lockerNameValue : lockerNameValue.name
			  }`
			: "ALL Lockers";
		// const partnerCompanyName =
		// 	selectedPartnerCompany === "-1"
		// 		? "All Partners"
		// 		: partnerCompany.find((item) => item.value === selectedPartnerCompany)
		// 				?.name;

		// const partnerBranchValue =
		// 	selectedPartnerBranch === 0 || selectedPartnerBranch === ""
		// 		? "All Branches"
		// 		: partnerBranch.find((item) => item.value == selectedPartnerBranch);

		// const partnerBranchText = partnerBranchValue
		// 	? partnerBranchValue.name
		// 	: "ALL Branches";

		//  //   ${partnerCompanyName},
		//   ${partnerBranchText},
		setSearchResultHeader(`for
      ${lockerTypeName},
      ${lockerNameText},
   
	  from ${formatDate(startDate)} to ${formatDate(endDate)}
    `);
	}

	const buildVariables = () => {
		const start = formatDateYYYYMMDD(startDate);
		const end = formatDateYYYYMMDD(endDate);
		const updatedVariables = {
			operatorId: operatorId,
			dateStart: start,
			dateEnd: end,
		};
		// Check each state and add to updatedVariables if not empty
		if (selectedStatus.trim() !== "200") {
			updatedVariables.selectedStatus = parseInt(selectedStatus);
		}
		if (selectedLockerName.trim() !== "-1" && selectedLockerType !== "-1") {
			if (selectedLockerName != "200") {
				updatedVariables.selectedLockerName = parseInt(selectedLockerName);
			}
		}
		if (selectedPartnerCompany.trim() !== "-1") {
			updatedVariables.selectedPartnerCompany = parseInt(
				selectedPartnerCompany
			);
		}
		if (
			selectedPartnerBranch.trim() !== "-1" &&
			selectedPartnerCompany.trim() !== "-1"
		) {
			updatedVariables.selectedPartnerBranch = parseInt(selectedPartnerBranch);
		}
		console.log(updatedVariables);
		return updatedVariables;
	};

	//Modal Handler
	function EmptyCriteriaHandler(e) {
		const TableVariables = buildVariables();
		if (selectedLockerType !== "-1" && selectedLockerName == "-1") {
			setDropOffStatusHistory([]);
			setisLoading(false);
			setNoResultSearch(true);
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Incomplete Criteria",
				message: `Please select a locker name.`,
				open: true,
				actions: (
					<div className="w-full">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2 w-full"}
						/>
					</div>
				),
			});
		} else if (selectedLockerType === "2" && lockerName.length === 1) {
			console.log("error no lockers found");
			setisLoading(false);
			setIsTableEmpty(true);
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Incomplete Criteria",
				message: `No Locker was found.`,
				open: true,
				actions: (
					<div className="w-full">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2 w-full"}
						/>
					</div>
				),
			});
		} else {
			QUERYdropOffStatusHistory({
				variables: TableVariables,
			});
			setNoResultSearch(false);
			setIsTableEmpty(false);
		}
	}

	const [noResultSearch, setNoResultSearch] = useState(false);

	const handleSearch = () => {
		setisLoading(true);
		handleSearchResultHeader();
		setDropOffStatusHistory([]);
		EmptyCriteriaHandler();
		setSelectedRadio("weekday");
		if (startDate == "" && endDate == "") {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Invalid Date",
				message: `Please select a date range.`,
				open: true,
				actions: (
					<div className="w-full">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2 w-full"}
						/>
					</div>
				),
			});
			setisLoading(false);
			return;
		} else if (endDate == "") {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Invalid Date",
				message: `No end date selected.`,
				open: true,
				actions: (
					<div className="w-full">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2 w-full"}
						/>
					</div>
				),
			});
			setisLoading(false);
			return;
		} else if (startDate > endDate) {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Invalid Date",
				message: `Start date must be before end date.`,
				open: true,
				actions: (
					<div className="w-full">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2 w-full"}
						/>
					</div>
				),
			});
			setisLoading(false);
			return;
		} else if (startDate == "") {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Invalid Date",
				message: `No start date selected.`,
				open: true,
				actions: (
					<div className="w-full">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2 w-full"}
						/>
					</div>
				),
			});
			setisLoading(false);
			return;
		}
	};

	const dt = useRef(null);
	return (
		<ContentContainer containerTitle={"Unrecognized Waybill Report"}>
			<h2 className={"font-bold"}>Locker:</h2>
			<div className={"grid grid-cols-2 w-1/2 gap-y-2"}>
				<p>Locker Type:</p>
				<Select
					items={lockerType}
					defaultOption={{ value: "-1", name: "-- Select Locker Type --" }}
					value={selectedLockerType}
					onChange={(event) => {
						setSelectedLockerType(event.target.value);
					}}
				/>
				<p>Locker Name:</p>
				<Select
					items={lockerName}
					defaultOption={{ value: "-1", name: "-- Select Locker Name --" }}
					disable={selectedLockerType !== "-1" ? false : true}
					value={selectedLockerName}
					onChange={(event) => {
						setSelectedLockerName(event.target.value);
					}}
				/>
			</div>
			<div className={"grid grid-cols-2 w-1/2 gap-y-2 mt-5"}>
				<h2 className={"font-bold"}>Status:</h2>
				<Select
					items={dropStatus}
					value={selectedStatus}
					onChange={(event) => {
						setSelectedStatus(event.target.value);
					}}
				/>
			</div>
			{/* <h2 className={"font-bold"}>Partner:</h2>
			<div className={"grid grid-cols-2 w-1/2 gap-y-2"}>
				<p>Partner Company:</p>
				<Select
					items={partnerCompany}
					defaultOption={{ value: "-1", name: "-- Select Partner --" }}
					value={selectedPartnerCompany}
					onChange={(event) => {
						setSelectedPartnerBranch("-1");
						setSelectedPartnerCompany(event.target.value);
					}}
				/>
				<p>Partner Branch:</p>
				<Select
					items={partnerBranch}
					defaultOption={{ value: "-1", name: "-- ALL --" }}
					value={selectedPartnerBranch}
					disable={selectedPartnerCompany !== "-1" ? false : true}
					onChange={(event) => {
						setSelectedPartnerBranch(event.target.value);
					}}
				/>
			</div> */}
			<h2 className={"font-bold"}>Date range:</h2>
			{/* <DateRangePicker
                className={"w-1/2"}
                startDate={startDate}
                endDate={endDate}
                onChange={(event) => {
                    if (event.target.name === "signupDateFrom") {
                        setStartDate(event.target.value);
                    } else {
                        setEndDate(event.target.value);
                    }
                }}
            /> */}
			<PrimereactDateRange
				className={"w-1/2"}
				startDate={startDate}
				endDate={endDate}
				onChange={(event) => {
					if (event.target.name === "signupDateFrom") {
						setStartDate(event.target.value);
					} else {
						setEndDate(event.target.value);
					}
				}}
				readOnlyInput={true}
				max={new Date()} // Today's date as the maximum
				min={new Date("2021-01-01")} // Jan 1, 2021, as the minimum
			/>

			<div className="grid grid-cols-2 w-1/2 gap-y-2">
				<div></div>
				<u
					className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
					onClick={() => {
						setSelectedLockerType("-1");
						setSelectedLockerName("-1");
						setSelectedPartnerCompany("-1");
						setSelectedStatus("200");
						setStartDate(new Date());
						setEndDate(new Date());
					}}
				>
					<i className="fas fa-undo my-auto"></i>
					<p className="ml-1">Reset</p>
				</u>
			</div>
			<Button
				value={"SEARCH"}
				onClick={(event) => {
					setisLoading(true);
					handleSearch(event, data);
				}}
				className={"w-40 h-8 m-5"}
			/>
			{isLoading && <LoadingComponent />}
			{dropOffStatusHistory.length > 0 && noResultSearch == false && (
				<div>
					<div className="flex flex-row gap-1">
						<p>Total: </p>
						<p className="font-bold">{dropOffStatusHistory.length}</p>
					</div>
					<DownloadButton dt={dt} id={"Unrecognized Waybills Report"} />
					<div id="Unrecognized Waybills Report">
						<div className={"grid grid-row-3 bg-yellow-400 p-2"}>
							<div className={"text-center"}>
								<span>
									<h1 className={"font-bold"}>Unrecognized Waybills Report</h1>
								</span>
								<span>
									<h1 className={"font-bold"}>{searchResultHeader}</h1>
								</span>
							</div>
						</div>
						<UnrecogTable
							headers={[
								{
									header_name: "Waybill Number",
									header_key: "waybill",
								},
								{
									header_name: "Courier",
									header_key: "courier",
								},
								{
									header_name: "Recipient",
									header_key: "recipient",
								},
								{
									header_name: "Drop-Off",
									header_key: "dropoff",
								},
								{
									header_name: "Status",
									header_key: "status",
								},
								{
									header_name: "Status Date",
									header_key: "statusDate",
								},
								{
									header_name: "Locker Name",
									header_key: "locker",
								},
								{ header_name: `${searchResultHeader}`, header_key: "blank" },
							]}
							items={dropOffStatusHistory}
							dt={dt}
							// linkName={"waybill"}
							// linkBody={`view-package-history-page`}
							// fieldId={["packageId", "userAccountId"]}
						/>
					</div>
				</div>
			)}
			{isTableEmpty ? <NoDataFoundTemplate /> : ""}
			<Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={validation.actions}
			/>
		</ContentContainer>
	);
};

export default UnrecognizedWaybill;
